import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class TrackPoints extends Phaser.GameObjects.Container {
  constructor(scene, val) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    const outlineColor = val > 0 ? '#000' : '#ee3739';
    const op = val > 0 ? '+' : '';
    const num = ABCyaPhaser.Text.addText(0, 0, 22, '0xFFFFFF', FontKeys._odin_roundedregular, op + val.toString(), this);
    num.setStroke(outlineColor, 3);

    // tween up and fade
    ABCyaPhaser.Tweens.addTween(num, 700, { y: -100 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(num, 400, { alpha: 0, delay: 400 }, Phaser.Math.Easing.Linear, () => {
      this.cleanUpPoints();
    });
  }

  cleanUpPoints() {
    if (this.parentContainer) super.destroy();
  };
}